import React, { type FC } from 'react'
import { TableCell, TableRow } from '@awell-health/design-system'
import { ActivityTypeIcon } from 'app-care/src/components/ActivityTypeIcon'
import { IconLabelCell } from 'app-care/src/components/IconLabelCell'
import type { Activity } from 'app-care/src/hooks/useActivityFeed'
import { isNil } from 'lodash'
import { formatDate } from '../../../utils'

interface ActivityRowProps {
  activity: Activity
  getActivityPathwayTitle: (activity: Activity) => string
}

export const ActivityRow: FC<ActivityRowProps> = ({ activity, getActivityPathwayTitle }) => {
  return (
    <TableRow>
      <TableCell className="font-normal">{getActivityPathwayTitle(activity)}</TableCell>
      <TableCell className="font-normal">{activity.container_name ?? '-'}</TableCell>
      <TableCell className="font-normal">
        <IconLabelCell
          label={activity.object.name}
          icon={<ActivityTypeIcon type={activity.object.type} />}
          status={activity.status}
          to={
            !isNil(activity.stream_id)
              ? `/pathway/${activity.stream_id}/activity-feed?activityId=${activity.id}`
              : undefined
          }
        />
      </TableCell>
      <TableCell className="font-normal">
        {formatDate(false)(activity.date ?? new Date().toISOString()) ?? '-'}
      </TableCell>
    </TableRow>
  )
}
